module.exports = __webpack_public_path__ + "img/img-2-3.ecfa8b53.png";